export const COUNSELLOR_OVERLAY_CONFIG = {
  'counsellor-freeform': {
    path: '/counsellors/freeform',
    landingPath: '/landing/counsellors/freeform',
    titleKey: 'chat_counsellor_freeform',
    bodyKey: 'counsellors_freeform_body',
  },
  'counsellor-technique': {
    path: '/counsellors/technique-guided',
    landingPath: '/landing/counsellors/technique-guided',
    titleKey: 'chat_counsellor_technique',
    bodyKey: 'counsellors_technique_body',
  },
  'counsellor-evoke': {
    path: '/counsellors/mibot-evoke',
    landingPath: '/landing/counsellors/mibot-evoke',
    titleKey: 'chat_counsellor_stage',
    bodyKey: 'counsellors_stage_body',
  },
};

export const COUNSELLOR_OVERLAY_IDS = Object.keys(COUNSELLOR_OVERLAY_CONFIG);

export function getCounsellorOverlayFromMode(mode) {
  if (mode === 'volley') return 'counsellor-freeform';
  if (mode === 'utterance_multiBC') return 'counsellor-technique';
  if (mode === 'stage_guided_multiBC') return 'counsellor-evoke';
  return 'counsellor-freeform';
}
